import { Routes } from '@angular/router';
import { CUSTOM_REDIRECTS } from './custom-redirects.constant';
import privateRoutes from './features/private/private.routes';
import publicRoutes from './features/public/public.routes';
import { LegacyTendersEmailRedirectGuard } from './shared/guards/redirect.guard';

export default [
  ...CUSTOM_REDIRECTS,
  {
    path: 'private',
    children: privateRoutes,
  },
  {
    path: 'upgrade',
    loadChildren: () =>
      import('./features/private/upgrade/upgrade.module').then((m) => m.UpgradeModule),
  },
  {
    path: '',
    canActivate: [LegacyTendersEmailRedirectGuard],
    children: publicRoutes,
  },
] satisfies Routes;
